import axios from 'axios'

export default {
  namespaced: true,
  state: {
    eligibleOrders: [],
    history: [],
    loading: false,
    historyLoading: false,
  },
  getters: {},
  mutations: {
    SET_ELIGIBLE_ORDERS(state, payload) {
      state.eligibleOrders = payload
    },
    SET_HISTORY(state, payload) {
      state.history = payload
    },
    SET_LOADING(state, payload) {
      state.loading = payload
    },
    SET_HISTORY_LOADING(state, payload) {
      state.historyLoading = payload
    },
  },
  actions: {
    fetchEligibleOrders(ctx, params) {
      ctx.commit('SET_LOADING', true)
      return new Promise((resolve, reject) => {
        axios
          .get('/api/orders/extra-fees/eligible-orders/', { params })
          .then(response => {
            const results = response.data.results || response.data
            ctx.commit('SET_ELIGIBLE_ORDERS', Array.isArray(results) ? results : [])
            resolve(response)
          })
          .catch(error => reject(error))
          .finally(() => {
            ctx.commit('SET_LOADING', false)
          })
      })
    },
    addExtraFee(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post('/api/orders/extra-fees/add/', data)
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    fetchHistory(ctx, params) {
      ctx.commit('SET_HISTORY_LOADING', true)
      return new Promise((resolve, reject) => {
        axios
          .get('/api/orders/extra-fees/history/', { params })
          .then(response => {
            const results = response.data.results || response.data
            ctx.commit('SET_HISTORY', Array.isArray(results) ? results : [])
            resolve(response)
          })
          .catch(error => reject(error))
          .finally(() => {
            ctx.commit('SET_HISTORY_LOADING', false)
          })
      })
    },
  },
}
